import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [status, setStatus] = useState("Signing you in…");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      setStatus("Missing session, redirecting…");
      navigate("/admin/login", { replace: true });
      return;
    }

    axios.post(`${API}/auth/session`, { session_id: sessionId })
      .then(async () => {
        await refresh();
        window.history.replaceState({}, "", window.location.pathname);
        navigate("/admin", { replace: true });
      })
      .catch(() => {
        setStatus("Sign-in failed. Please retry.");
        setTimeout(() => navigate("/admin/login", { replace: true }), 1500);
      });
  }, [navigate, refresh]);

  return (
    <div className="py-24 text-center">
      <div className="inline-block w-8 h-8 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
      <p className="mt-4 text-slate-500 dark:text-slate-400 text-sm">{status}</p>
    </div>
  );
}
